<script setup>
import { GlobeAltIcon, CameraIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { ref } from 'vue'

const show_logo = ref(false)
</script>

<template>
    <div
        class="inline"
        v-on:mouseleave="show_logo = false"
    >
        <div>
            <div class="flex space-x-6 rounded-full bg-gray-50 p-3">
                <div
                    @click="show_logo = true"
                    v-on:mouseover="show_logo = true"
                >
                    <img
                        class="size-8 xl:size-12"
                        src="/src/footer/rahomadigital-logo.png"
                        alt="Rahoma digital"
                        loading="lazy"
                    />
                </div>
            </div>
        </div>

        <div
            class="absolute left-1/2 z-50 flex w-[20rem] -translate-x-1/2 items-center justify-center md:w-[20rem] md:justify-start"
            v-on:mouseleave="show_logo = false"
        >
            <Transition name="fade">
                <div
                    v-if="show_logo"
                    class="absolute bottom-0 w-full overflow-hidden rounded-xl shadow-md shadow-gray-400"
                >
                    <div class="bg-gradient-to-br from-orange-300 via-gray-200 to-gray-300 px-5 py-4">
                        <ul class="relative flex flex-col items-center justify-center">
                            <li class="text-sm uppercase text-gray-500">marketing</li>

                            <li class="font-robotoSlab text-lg font-extrabold tracking-wide text-gray-900">RAHOMA Digital</li>

                            <li class="py-4 md:py-4">
                                <img
                                    class="h-16 w-16 xl:h-20 xl:w-20"
                                    src="/src/footer/rahomadigital-logo.png"
                                    alt="rahoma digital"
                                    loading="lazy"
                                />
                            </li>

                            <li class="relative grid grid-cols-12 gap-x-3">
                                <a
                                    class="group col-span-4 flex flex-col items-center"
                                    target="_blank"
                                    href="https://rahomadigital.cz/"
                                    aria-label="rahoma digital"
                                    rel="noopener noreferrer"
                                >
                                    <GlobeAltIcon
                                        class="h-8 w-8 text-gray-500 transition-all delay-200 duration-100 ease-linear group-hover:text-orange-300 xl:h-10 xl:w-10"
                                    />

                                    <span
                                        class="font-bold tracking-wider text-gray-500 transition-all delay-200 duration-100 ease-linear group-hover:text-orange-500"
                                    >
                                        Web
                                    </span>
                                </a>

                                <a
                                    class="group col-span-4 flex flex-col items-center"
                                    target="_blank"
                                    href="https://www.instagram.com/rahomadigital/"
                                    aria-label="rahoma digital"
                                    rel="noopener noreferrer"
                                >
                                    <CameraIcon
                                        class="h-8 w-8 text-gray-500 transition-all delay-200 duration-100 ease-linear group-hover:text-orange-300 xl:h-10 xl:w-10"
                                    />

                                    <span
                                        class="font-bold tracking-wider text-gray-500 transition-all delay-200 duration-100 ease-linear group-hover:text-orange-500"
                                    >
                                        Instagram
                                    </span>
                                </a>

                                <button
                                    class="group col-span-4 flex flex-col items-center"
                                    @click="show_logo = false"
                                    aria-label="zavřít"
                                >
                                    <XMarkIcon
                                        class="h-8 w-8 text-gray-500 transition-all delay-200 duration-100 ease-linear group-hover:text-red-300 xl:h-10 xl:w-10"
                                    />

                                    <span
                                        class="font-bold tracking-wider text-gray-500 transition-all delay-200 duration-100 ease-linear group-hover:text-red-500"
                                    >
                                        Zavřít
                                    </span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </Transition>
        </div>
    </div>
</template>

<style>
.fade-enter-active {
    animation: bounce-in 0.5s;
}

.fade-leave-active {
    animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }

    50% {
        transform: scale(1.25);
    }

    100% {
        transform: scale(1);
    }
}
</style>
